// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_n-z","heading":"ao-z"};